import React from 'react';
import styles from './entity-skill-scores-card.module.css';
import { IEntitySkillScoresCardProps } from './entity-skill-scores-card.models';
import classNames from 'classnames';
import { UrgencyIndicationChip } from '../../chips/urgency-indication.chip';
import { SkillScore } from '../../general/skill-score/skill-score';
import { comparisonScoreTitle } from '../../../library/helpers/comparison-score-title';
import { ScoreComparison } from '../../../enums/score-comparison';

export function EntitySkillScoresCard({ score, comparisonScore, scoreComparison, name, urgencyIndication, skillScoreTitle, skillScoreUseRAGColours }: IEntitySkillScoresCardProps) {
  return (
    <div className={classNames('card', 'kplr_entitySkillLevelCard')}>
      <h3 className={styles.cardTitle}>{name}</h3>
      <div className={styles.cardContent}>
        {!!urgencyIndication ? (
          <UrgencyIndicationChip urgencyIndication={urgencyIndication} />
        ) : (
          <React.Fragment>
            <div className={styles.skillScore}>
              <SkillScore score={score} title={skillScoreTitle} useRAGColours={skillScoreUseRAGColours} />
            </div>

            {scoreComparison !== ScoreComparison.None && (
              <div className={styles.skillScore}>
                <SkillScore score={comparisonScore} title={comparisonScoreTitle(scoreComparison)} useRAGColours={skillScoreUseRAGColours} noScoreText="Not captured" />
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
}
